import { render, staticRenderFns } from "./VModal.vue?vue&type=template&id=6134e73b&"
import script from "./VModal.vue?vue&type=script&lang=js&"
export * from "./VModal.vue?vue&type=script&lang=js&"
import style0 from "./VModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports